import { render, staticRenderFns } from "./FakeFormBlock.vue?vue&type=template&id=4eb42a44&"
import script from "./FakeFormBlock.vue?vue&type=script&lang=ts&"
export * from "./FakeFormBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports